<div
  class="tw-relative tw-hidden lg:tw-flex tw-flex-col invitation-collection-desktop"
  [style.--invitation-collection-table-viewport-height.px]="viewportHeightPx()"
>
  <app-generic-table
    class="invitation-collection-table tw-w-full tw-min-w-0 tw-h-auto"
    [items]="items()"
    [trackBy]="trackBy()"
    [rowKey]="rowKey()"
    [selectable]="true"
    [selectedKeys]="selectedKeys()"
    [selectAllScope]="'allCollection'"
    [isAllCollectionSelected]="isAllCollectionSelected()"
    [hasCollectionSelection]="hasCollectionSelection()"
    [pageSize]="perPage()"
    [sort]="sort()"
    [hasMore]="hasMore()"
    [isLoadingMore]="isLoadingMore()"
    [isLoading]="isLoading()"
    [rowHeightPx]="tableRowHeightPx"
    [autoFillViewport]="true"
    [responsiveColumns]="responsiveColumns()"
    [highlightedRowKey]="highlightedRowKey()"
    [virtualScrollMinBufferPx]="virtualScrollMinBufferPx()"
    [virtualScrollMaxBufferPx]="virtualScrollMaxBufferPx()"
    (selectionChange)="selectionChange.emit($event)"
    (selectAllCollectionChange)="selectAllCollectionChange.emit($event)"
    (sortChange)="sortChange.emit($event)"
    (loadMore)="loadMore.emit()"
  >
    <ng-container appGenericTableColumn field="fullname" header="Full name" [sortable]="true" width="156px" widthXl="156px">
      <ng-template appGenericTableCellDef let-item>
        <app-truncation-tooltip
          [text]="item.fullname"
          [hostNgClass]="'tw-font-inter tw-font-medium tw-text-sm tw-text-gray-900'"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="email" header="Email" [sortable]="true" width="200px" widthXl="200px">
      <ng-template appGenericTableCellDef let-item>
        @if (item.email) {
          <app-truncation-tooltip
            [text]="item.email"
            [hostNgClass]="'tw-font-inter tw-font-normal tw-text-sm tw-text-gray-700'"
          ></app-truncation-tooltip>
        }
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="phone_number" header="Phone number" [sortable]="true" width="154px" widthXl="154px">
      <ng-template appGenericTableCellDef let-item>
        @if (item.phone_number) {
          <app-truncation-tooltip
            [text]="item.phone_number"
            [hostNgClass]="'tw-font-inter tw-font-normal tw-text-sm tw-text-gray-700'"
          ></app-truncation-tooltip>
        }
      </ng-template>
    </ng-container>

    <ng-container
      appGenericTableColumn
      field="invitation"
      header="Invitation status"
      width="180px"
      widthXl="180px"
      maxWidth="180px"
      cellPadding="none"
      [skeletonBlockCount]="3"
      skeletonLayout="row"
    >
      <ng-template appGenericTableCellDef let-item>
        <div class="tw-flex tw-w-full tw-min-w-0 tw-max-w-full tw-items-center">
          @for (channelStatus of channelStatusesFor(item); track channelStatus.channel) {
            @let channelAvailable = isChannelAvailable(item, channelStatus.channel);
            @let iconFill = channelIconFill(channelAvailable);
            <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-justify-center">
              <div class="tw-relative tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-w-7 tw-h-7 tw-rounded-full tw-bg-gray-200">
                @if (channelAvailable && channelStatus.color) {
                  <span
                    class="tw-absolute tw-top-[-2px] tw-right-[-2px] tw-w-2.5 tw-h-2.5 tw-rounded-[5px] tw-border-[1.667px] tw-border-white"
                    [ngClass]="channelDotClass(channelStatus.color)"
                  ></span>
                }

                @switch (channelStatus.channel) {
                  @case ('email') {
                    @if (channelAvailable) {
                      <app-invitation-channel-popover
                        [collectionItemId]="item.id"
                        [channel]="'email'"
                        [history]="channelHistory()"
                        [isSending]="isSendingInvitation()"
                        [actionTaken]="item.action_taken"
                        [inviteeName]="item.fullname"
                        [channelLatestStatus]="channelLatestStatusFor(item, channelStatus.channel)"
                        [isOptOut]="item.is_opt_out"
                        [isEventFinished]="isEventFinished()"
                        (opened)="channelPanelOpened.emit($event)"
                        (loadMoreHistory)="loadMoreChannelHistory.emit()"
                        (sendInvitation)="sendInvitation.emit($event)"
                      >
                        <svg class="tw-w-4 tw-h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 8.6398L13.4925 3.0804C13.2432 2.86859 12.9271 2.75158 12.6 2.75H2.4C2.07287 2.75158 1.7568 2.86859 1.5075 3.0804L8 8.6398Z" [attr.fill]="iconFill" />
                          <path
                            d="M8.875 9.7339C8.62024 9.92877 8.30884 10.0352 7.9881 10.037C7.6892 10.0376 7.39824 9.94079 7.1593 9.7612L2 4.4888V11.85C2 12.2213 2.1475 12.5774 2.41005 12.8399C2.6726 13.1025 3.0287 13.25 3.4 13.25H12.6C13.0313 13.25 13.3774 13.1025 13.5899 12.8399C13.8525 12.5774 14 12.2213 14 11.85V4.4888L8.875 9.7339Z"
                            [attr.fill]="iconFill"
                          />
                        </svg>
                      </app-invitation-channel-popover>
                    } @else {
                      <span class="tw-inline-flex tw-shrink-0">
                        <svg class="tw-w-4 tw-h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 8.6398L13.4925 3.0804C13.2432 2.86859 12.9271 2.75158 12.6 2.75H2.4C2.07287 2.75158 1.7568 2.86859 1.5075 3.0804L8 8.6398Z" [attr.fill]="iconFill" />
                          <path
                            d="M8.875 9.7339C8.62024 9.92877 8.30884 10.0352 7.9881 10.037C7.6892 10.0376 7.39824 9.94079 7.1593 9.7612L2 4.4888V11.85C2 12.2213 2.1475 12.5774 2.41005 12.8399C2.6726 13.1025 3.0287 13.25 3.4 13.25H12.6C13.0313 13.25 13.3774 13.1025 13.5899 12.8399C13.8525 12.5774 14 12.2213 14 11.85V4.4888L8.875 9.7339Z"
                            [attr.fill]="iconFill"
                          />
                        </svg>
                      </span>
                    }
                  }
                  @case ('whatsapp') {
                    @if (channelAvailable) {
                      <app-invitation-channel-popover
                        [collectionItemId]="item.id"
                        [channel]="'whatsapp'"
                        [history]="channelHistory()"
                        [isSending]="isSendingInvitation()"
                        [actionTaken]="item.action_taken"
                        [inviteeName]="item.fullname"
                        [channelLatestStatus]="channelLatestStatusFor(item, channelStatus.channel)"
                        [isOptOut]="item.is_opt_out"
                        [isEventFinished]="isEventFinished()"
                        (opened)="channelPanelOpened.emit($event)"
                        (loadMoreHistory)="loadMoreChannelHistory.emit()"
                        (sendInvitation)="sendInvitation.emit($event)"
                      >
                        <svg class="tw-w-[17px] tw-h-[17px]" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.99818 1.16699C3.77643 1.16699 1.16406 3.77876 1.16406 7.00051C1.16406 8.10281 1.47009 9.13551 2.00268 10.015L1.48234 11.7838C1.45247 11.8854 1.4505 11.9931 1.47665 12.0957C1.5028 12.1983 1.55611 12.2919 1.63095 12.3667C1.7058 12.4416 1.79944 12.4949 1.90201 12.521C2.00458 12.5472 2.11229 12.5452 2.21384 12.5153L3.98251 11.9949C4.89174 12.5451 5.93448 12.8353 6.99818 12.8338C10.2199 12.8338 12.8315 10.2222 12.8315 7.00051C12.8315 3.77876 10.2199 1.16699 6.99818 1.16699ZM5.67768 8.32057C6.85776 9.50007 7.98418 9.65582 8.38199 9.67045C8.98693 9.69257 9.57612 9.23057 9.80537 8.69451C9.83428 8.6278 9.84478 8.55458 9.83575 8.48248C9.82672 8.41031 9.79851 8.34192 9.75399 8.28445C9.43437 7.87607 9.00212 7.5827 8.57974 7.29101C8.49161 7.23004 8.38325 7.20561 8.27741 7.22276C8.17157 7.23998 8.07651 7.29745 8.01218 7.3832L7.66218 7.91695C7.64377 7.94565 7.61507 7.96623 7.58203 7.97442C7.54892 7.98268 7.51399 7.97799 7.48424 7.96126C7.24687 7.82532 6.90093 7.59432 6.65243 7.34582C6.40393 7.09732 6.18693 6.76718 6.06501 6.54493C6.04989 6.51669 6.04552 6.48393 6.05271 6.45273C6.05989 6.42151 6.07815 6.39396 6.10409 6.37518L6.64309 5.97501C6.72002 5.90813 6.76966 5.81529 6.78257 5.71418C6.79547 5.61307 6.77074 5.51074 6.71309 5.42668C6.45176 5.04401 6.14726 4.55751 5.70568 4.23493C5.64869 4.19363 5.58193 4.16788 5.51197 4.16021C5.44201 4.15254 5.37126 4.16321 5.30668 4.19118C4.77001 4.42101 4.30568 5.01018 4.32784 5.61626C4.34243 6.0141 4.49818 7.14051 5.67768 8.32057Z"
                            [attr.fill]="iconFill"
                          />
                        </svg>
                      </app-invitation-channel-popover>
                    } @else {
                      <span class="tw-inline-flex tw-shrink-0">
                        <svg class="tw-w-[17px] tw-h-[17px]" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M6.99818 1.16699C3.77643 1.16699 1.16406 3.77876 1.16406 7.00051C1.16406 8.10281 1.47009 9.13551 2.00268 10.015L1.48234 11.7838C1.45247 11.8854 1.4505 11.9931 1.47665 12.0957C1.5028 12.1983 1.55611 12.2919 1.63095 12.3667C1.7058 12.4416 1.79944 12.4949 1.90201 12.521C2.00458 12.5472 2.11229 12.5452 2.21384 12.5153L3.98251 11.9949C4.89174 12.5451 5.93448 12.8353 6.99818 12.8338C10.2199 12.8338 12.8315 10.2222 12.8315 7.00051C12.8315 3.77876 10.2199 1.16699 6.99818 1.16699ZM5.67768 8.32057C6.85776 9.50007 7.98418 9.65582 8.38199 9.67045C8.98693 9.69257 9.57612 9.23057 9.80537 8.69451C9.83428 8.6278 9.84478 8.55458 9.83575 8.48248C9.82672 8.41031 9.79851 8.34192 9.75399 8.28445C9.43437 7.87607 9.00212 7.5827 8.57974 7.29101C8.49161 7.23004 8.38325 7.20561 8.27741 7.22276C8.17157 7.23998 8.07651 7.29745 8.01218 7.3832L7.66218 7.91695C7.64377 7.94565 7.61507 7.96623 7.58203 7.97442C7.54892 7.98268 7.51399 7.97799 7.48424 7.96126C7.24687 7.82532 6.90093 7.59432 6.65243 7.34582C6.40393 7.09732 6.18693 6.76718 6.06501 6.54493C6.04989 6.51669 6.04552 6.48393 6.05271 6.45273C6.05989 6.42151 6.07815 6.39396 6.10409 6.37518L6.64309 5.97501C6.72002 5.90813 6.76966 5.81529 6.78257 5.71418C6.79547 5.61307 6.77074 5.51074 6.71309 5.42668C6.45176 5.04401 6.14726 4.55751 5.70568 4.23493C5.64869 4.19363 5.58193 4.16788 5.51197 4.16021C5.44201 4.15254 5.37126 4.16321 5.30668 4.19118C4.77001 4.42101 4.30568 5.01018 4.32784 5.61626C4.34243 6.0141 4.49818 7.14051 5.67768 8.32057Z"
                            [attr.fill]="iconFill"
                          />
                        </svg>
                      </span>
                    }
                  }
                  @case ('sms') {
                    <span
                      class="tw-inline-flex tw-shrink-0 tw-cursor-not-allowed"
                      [ngxTippy]="comingSoonTooltip"
                      [tippyProps]="{ theme: 'dark' }"
                      aria-disabled="true"
                      [attr.aria-label]="'SMS — ' + comingSoonTooltip"
                    >
                      <svg class="tw-w-4 tw-h-4" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M14.6 0.583333H1.4C0.9713 0.583333 0.672601 0.733556 0.41005 1.00095C0.1475 1.26835 0 1.63102 0 2.00918V9.13842C0 9.51658 0.1475 9.87925 0.41005 10.1467C0.672601 10.414 1.0287 10.5643 1.4 10.5643H4.3822L7.1222 13.1729C7.1879 13.2494 7.26893 13.3108 7.35984 13.3529C7.45076 13.3949 7.54945 13.4167 7.6493 13.4167C7.74915 13.4167 7.84784 13.3949 7.93876 13.3529C8.02967 13.3108 8.1107 13.2494 8.1764 13.1729L10.4178 10.5643H14.6C15.0313 10.5643 15.3774 10.414 15.5899 10.1467C15.8525 9.87925 16 9.51658 16 9.13842V2.00918C16 1.63102 15.8525 1.26835 15.5899 1.00095C15.3274 0.733556 14.9713 0.583333 14.6 0.583333ZM8 7.71258H4C3.81435 7.71258 3.6363 7.63746 3.50503 7.50376C3.37375 7.37007 3.3 7.18873 3.3 6.99965C3.3 6.81057 3.37375 6.62924 3.50503 6.49554C3.6363 6.36184 3.81435 6.28673 4 6.28673H8C8.18565 6.28673 8.3637 6.36184 8.49497 6.49554C8.62625 6.62924 8.7 6.81057 8.7 6.99965C8.7 7.18873 8.62625 7.37007 8.49497 7.50376C8.3637 7.63746 8.18565 7.71258 8 7.71258ZM12 4.86088H4C3.81435 4.86088 3.6363 4.78577 3.50503 4.65207C3.37375 4.51837 3.3 4.33703 3.3 4.14795C3.3 3.95887 3.37375 3.77754 3.50503 3.64384C3.6363 3.51014 3.81435 3.43503 4 3.43503H12C12.1857 3.43503 12.3637 3.51014 12.495 3.64384C12.6263 3.77754 12.7 3.95887 12.7 4.14795C12.7 4.33703 12.6263 4.51837 12.495 4.65207C12.3637 4.78577 12.1857 4.86088 12 4.86088Z"
                          [attr.fill]="iconFill"
                        />
                      </svg>
                    </span>
                  }
                }
              </div>
            </div>
          }
        </div>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="count" header="Count" [sortable]="true" width="96px" align="center">
      <ng-template appGenericTableCellDef let-item>
        <p class="tw-font-inter tw-font-medium tw-text-sm tw-text-gray-700 tw-text-center tw-w-full">{{ item.count }}</p>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="cost" header="T Cost" [sortable]="true" width="97px" align="center">
      <ng-template appGenericTableCellDef let-item>
        <p class="tw-font-inter tw-font-medium tw-text-sm tw-text-gray-700 tw-text-center tw-w-full">${{ item.cost }}</p>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="action_taken" header="Action taken" [sortable]="true" width="125px" widthXl="125px">
      <ng-template appGenericTableCellDef let-item>
        <app-truncation-tooltip
          [badge]="true"
          [text]="formatActionTakenLabel(item.action_taken)"
          [hostNgClass]="actionTakenBadgeClass(item.action_taken)"
        ></app-truncation-tooltip>
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="source_type" header="Source" [sortable]="true" width="157px" widthXl="157px">
      <ng-template appGenericTableCellDef let-item>
        @let sourceLabel = formatSourceLabel(item);
        @if (sourceLabel) {
          <button
            type="button"
            class="tw-group tw-flex tw-min-w-0 tw-max-w-full tw-p-0 tw-bg-transparent tw-border-0 tw-text-left tw-cursor-pointer focus:tw-outline-none"
            (click)="onSourceClick(item)"
          >
            <app-truncation-tooltip
              [text]="sourceLabel"
              [hostNgClass]="'tw-font-inter tw-font-normal tw-text-sm tw-text-blue-600 group-hover:tw-underline group-focus-visible:tw-underline'"
            ></app-truncation-tooltip>
          </button>
        }
      </ng-template>
    </ng-container>

    <ng-container appGenericTableColumn field="remove" header="Remove" width="83px" align="center" [skeletonBlockCount]="1">
      <ng-template appGenericTableCellDef let-item>
        <div class="tw-flex tw-h-[22px] tw-w-[51px] tw-items-center tw-justify-center">
          @if (canRemoveItem(item)) {
            <button
              type="button"
              class="tw-flex tw-h-[22px] tw-w-[22px] tw-items-center tw-justify-center tw-rounded-lg tw-text-gray-500 tw-cursor-pointer tw-border-0 tw-bg-transparent"
              (click)="onRemoveItem(item)"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.7055 2.94737H9.85366V1.47368C9.85366 1.08284 9.70343 0.708001 9.43602 0.431632C9.16861 0.155263 8.80592 0 8.42774 0H5.57589C5.19771 0 4.83502 0.155263 4.5676 0.431632C4.30019 0.708001 4.14996 1.08284 4.14996 1.47368V2.94737H1.29811C1.10902 2.94737 0.927673 3.025 0.793966 3.16318C0.66026 3.30137 0.585144 3.48879 0.585144 3.68421C0.585144 3.87963 0.66026 4.06705 0.793966 4.20524C0.927673 4.34342 1.10902 4.42105 1.29811 4.42105H2.01107V12.5263C2.01107 12.9172 2.1613 13.292 2.42871 13.5684C2.69613 13.8447 3.05882 14 3.437 14H10.5666C10.9448 14 11.3075 13.8447 11.5749 13.5684C11.8423 13.292 11.9926 12.9172 11.9926 12.5263V4.42105H12.7055C12.8946 4.42105 13.076 4.34342 13.2097 4.20524C13.3434 4.06705 13.4185 3.87963 13.4185 3.68421C13.4185 3.48879 13.3434 3.30137 13.2097 3.16318C13.076 3.025 12.8946 2.94737 12.7055 2.94737ZM5.57589 1.47368H8.42774V2.94737H5.57589V1.47368ZM6.28885 11.0526C6.28885 11.2481 6.21373 11.4355 6.08003 11.5737C5.94632 11.7118 5.76498 11.7895 5.57589 11.7895C5.3868 11.7895 5.20545 11.7118 5.07174 11.5737C4.93804 11.4355 4.86292 11.2481 4.86292 11.0526V5.89474C4.86292 5.69931 4.93804 5.5119 5.07174 5.37371C5.20545 5.23553 5.3868 5.1579 5.57589 5.1579C5.76498 5.1579 5.94632 5.23553 6.08003 5.37371C6.21373 5.5119 6.28885 5.69931 6.28885 5.89474V11.0526ZM9.1407 11.0526C9.1407 11.2481 9.06559 11.4355 8.93188 11.5737C8.79817 11.7118 8.61683 11.7895 8.42774 11.7895C8.23865 11.7895 8.0573 11.7118 7.9236 11.5737C7.78989 11.4355 7.71477 11.2481 7.71477 11.0526V5.89474C7.71477 5.69931 7.78989 5.5119 7.9236 5.37371C8.0573 5.23553 8.23865 5.1579 8.42774 5.1579C8.61683 5.1579 8.79817 5.23553 8.93188 5.37371C9.06559 5.5119 9.1407 5.69931 9.1407 5.89474V11.0526Z" fill="#E02424"/>
              </svg>
            </button>
          }
        </div>
      </ng-template>
    </ng-container>
  </app-generic-table>
</div>
